import React from "react";
import RiskAssessmentComponent from "./riskassessment/RiskAssessment";

/**
 * RiskAssessmentTab — dedicated top-level surface for the Investor Risk
 * Profile assessment + results.
 *
 * Previously this lived inside `ProfileTab` alongside the static
 * Financial Profile Summary. Promoted to its own sidebar entry on
 * 2026-06-17 because: (a) it's a substantial feature that warrants
 * top-level discoverability, (b) the student mental model of "my risk
 * profile" is distinct from "my financial profile summary," and (c) it
 * sets up the future stock-to-profile migration feature where research
 * picks will flow into this surface.
 *
 * State lifting is unchanged — `riskAssessmentData` and
 * `setRiskAssessmentData` still live in FinancialDashboard and are
 * persisted to Firestore via the existing save flow.
 */
const RiskAssessmentTab = ({
  questions,
  calculateResults,
  QuestionSlider,
  ProgressBar,
  CryptoReportView,
  logo,
  riskAssessmentData,
  setRiskAssessmentData,
}) => {
  // Defensive: if any of the required props haven't loaded yet, show a
  // brief skeleton instead of crashing. This matches the conditional
  // render pattern that used to live in ProfileTab.
  const ready =
    questions && calculateResults && QuestionSlider && ProgressBar && CryptoReportView;

  if (!ready) {
    return (
      <div className="surface-xl p-8 text-center">
        <p className="text-arc-muted text-sm">Loading Risk Profile…</p>
      </div>
    );
  }

  return (
    <RiskAssessmentComponent
      questions={questions}
      calculateResults={calculateResults}
      QuestionSlider={QuestionSlider}
      ProgressBar={ProgressBar}
      CryptoReportView={CryptoReportView}
      logo={logo}
      riskAssessmentData={riskAssessmentData}
      setRiskAssessmentData={setRiskAssessmentData}
    />
  );
};

export default RiskAssessmentTab;
